import React, { useState, useEffect, useCallback, use } from 'react';
// NOTE: Migrating from @shopify/polaris React components to Polaris Web Components
// Removed: Text, Card, InlineStack, ButtonGroup, Button, Banner, Box (migrated to s-text, s-section, s-stack, s-button-group, s-button, s-banner, s-box)
// Removed: TextField, FormLayout, InlineGrid, IndexTable, Pagination, EmptySearchResult, Collapsible, Tabs, Spinner, Layout, Modal, Frame, ProgressBar, Icon (migrating to web components)
// import { useBreakpoints } from '@shopify/polaris';
import axios from 'axios';
import Presets from '../../common/Presets';
import { getMappedTemplates, getShopUrl } from '../../Services/CommonServices';
import { environment } from '../../Services/environment';
import { timezoneOptions } from '../../common/TimezoneOptions';
import CSVMapping from '../CSVMapping';
import { ToastMarkup } from '../../common/ToastMarkup';
import '../../CSS/setup.module.css';
import { outlineSvg } from '../../common/svgs';
const endpoint = environment.serverUrl;

const FTPConnection = ({ ftpConfig, setFtpConfig, setSavedConfigs, mappingHtml, schedulerConfig, schedulerConfigHistory, action, setXmlConfigAction, jobId, setJobId, templateId, integrationConfig, setIntegrationConfig, setCompletedSteps, completed, fetchMappingData, ftpFields, shopifyFields, refreshConfigList, onModalClose, selectedIntegration  }) => {

  var storeUrl = getShopUrl();
  const [expanded, setExpanded] = useState(1);
  const [ftpConnection, setFTPConnection] = useState(null);
  const [showBanner, setShowBanner] = useState(false);
  const [saveLoading, setSaveLoading] = useState(false);
  const [testLoading, setTestLoading] = useState(false);
  const [pageNo, setPageNo] = useState(1);
  const [pageSize, setPageSize] = useState(8); // items per page
  const [hasMore, setHasMore] = useState(false);
  const [selected, setSelected] = useState(0);
  // const [ftpHeaders, setFtpHeaders] = useState([]);

  const [selectedTemplateID, setSelectedTemplateID] = useState("0");
  const [selectedTemplate, setSelectedTemplate] = useState();
  const [existingTemplates, setExistingTemplates] = useState([]);
  const [FormLoading, setFormLoading] = useState(false);

  const [presetModalActive, setPresetModalActive] = useState(false);
  const [setupActive, setSetupActive] = useState(false);
  const handleSetupOpen = useCallback(() => { setCompletedSteps((prev) => ({ ...prev, step1: false, step2: false })); setSetupActive(true); }, []);
  const [shopifyHeaders, setShopifyHeaders] = useState([]);
  const handleSetupClose = useCallback(() => {
    setSetupActive(false);
    setCompletedSteps((prev) => ({ ...prev, step1: false, step2: false }));
    setXmlConfigAction('Create');
    setJobId(null);
  }, []);

  const [toast, setToast] = useState(false);
  const toggleToast = useCallback(() => setToast((toast) => !toast), []);

  // Initialize timezone if not set
  useEffect(() => {
    if (!integrationConfig.timeZone && setIntegrationConfig) {
      const defaultTimeZone = timezoneOptions[0]?.value || 'UTC';
      setIntegrationConfig((prev) => ({ ...prev, timeZone: defaultTimeZone }));
    }
  }, []);

  // Control modal show/hide
  useEffect(() => {
    const modal = document.getElementById('ftp-connection-modal');
    if (!modal) return;

    if (setupActive) {

      modal.showOverlay();
    } else {

      modal.hideOverlay();
    }
  }, [setupActive]);

  // Handle modal hide event
  useEffect(() => {
    const modal = document.getElementById('ftp-connection-modal');
    if (!modal) return;

    const handleHide = () => {

      setSetupActive(false);
      setXmlConfigAction('');
      setCompletedSteps((prev) => ({ ...prev, step1: false, step2: false }));
      setJobId(null);
      if (onModalClose) {
        onModalClose();
      }
    };

    modal.addEventListener('hide', handleHide);
    return () => modal.removeEventListener('hide', handleHide);
  }, [onModalClose]);

  useEffect(() => {

    if (completed.step1 && completed.step2) {
      setExpanded(0);
    }

    else if (completed.step1) {
      setExpanded(2);
      if (action === "create" || action === "createExpand") {
        fetchMappingData();
      }
      else if (action === "edit" || action === "editExpand") {
        fetchMappingData();
        handleEdit(selectedTemplateID);
      }
    }
    else {
      setExpanded(1);
    }
  }, [completed]);

  useEffect(() => {

    
    // Only process if this is an FTP integration action
    if (selectedIntegration !== 'FTP') {
      return;
    }
    
    if ((action === 'edit' || action === 'editExpand') && jobId) {

      setCompletedSteps((prev) => ({ ...prev, step1: false, step2: false }));
      setExpanded(1);
      setFormLoading(true);
      getTemplates();
      setSetupActive(true);
      getConfigById();
    }
    if (action === 'create' || action === 'createExpand') {

      setSetupActive(true);
    }
    if (action === 'delete' && jobId) {
      deleteConfigById(jobId);
    }
  }, [action, jobId, selectedIntegration]);

  useEffect(() => {

    }, [ftpFields]);
  
    useEffect(() => {

        if (shopifyFields && shopifyFields.length > 0) {
          const optionsWithDefault = ["Select a value", ...shopifyFields];
          setShopifyHeaders(optionsWithDefault);

        }
      }, [shopifyFields]);


  const deleteConfigById = async (deleteId) => {
    const response = await fetch(
      `${endpoint}/api/Integrations/config-delete?storeUrl=${storeUrl}&jobId=${deleteId}`,
      {
        method: 'DELETE',
      }
    );

    if (!response.ok) {
      throw new Error('Failed to delete XML config');
    }
    const result = await response.json();
    setXmlConfigAction("refresh");
  };

  const getConfigById = async () => {
    const response = await fetch(`${endpoint}/api/Integrations/config-jobid?jobId=${jobId}&storeUrl=${storeUrl}`);
    if (!response.ok) {
      throw new Error('Failed to fetch FTP config');
    }
    else {
      const data = await response.json();

      // Update FTP-specific fields
      updateField('name', data.ftpConfig?.name || '');
      updateField('host', data.ftpConfig?.host || '');
      updateField('username', data.ftpConfig?.username || '');
      updateField('password', data.ftpConfig?.password || '');
      updateField('filePath', data.ftpConfig?.filePath || '');
      // Update integration config fields (for cron scheduler)
      updateIntegrationField('cronExpression', data.cronExpression || '');
      updateIntegrationField('jobName', data.jobName || '');
      updateIntegrationField('timeZone', data.timeZone || timezoneOptions[0]?.value || 'UTC');
      setSelectedTemplateID(data.templateId ?? "0");
      setFormLoading(false);
    }
  }
  
  const updateField = (field, value) => {
    setFtpConfig((prev) => ({ ...prev, [field]: value }));
    setShowBanner(false);
  };
  
  const updateIntegrationField = (field, value) => {
    setIntegrationConfig((prev) => ({ ...prev, [field]: value }));
  };
  useEffect(() => {
    GetFtpConfig(pageNo, pageSize);
  }, [pageNo, pageSize]);



  const handleEdit = (id) => {
    const template = existingTemplates?.find(
      (t) => t.id === parseInt(id)
    );
    if (template !== null && template !== undefined) {
      fetchMappingData();
      setPresetModalActive(true);
      setSelectedTemplate(id);
    }
    else {
      setSelectedTemplateID("0");
    }
  };

  // const handleEdit = (id) => {
  //   // setExpanded(1);
  //   console.log("existingTemplates:", existingTemplates);
  //   console.log("Editing template ID:", id);
  //   const template = existingTemplates?.find(
  //     (t) => t.id === parseInt(id)
  //   );
  //   console.log("template:", template);
  //   if (template !== null && template !== undefined) {
  //     console.log("parsedTemplate:", template);
  //     const templateJson = template?.template;

  //     const parsedTemplate = JSON.parse(templateJson);
  //     console.log("parsedTemplate:", parsedTemplate);
  //     const csvHeaderSet = new Set();
  //     const shopifyHeaderSet = new Set();
  //     parsedTemplate?.productMapping?.forEach(item => {
  //       if (item?.csvHeader) csvHeaderSet.add(item.csvHeader.trim());
  //       item?.shopifyHeaders?.forEach(sh => {
  //         if (sh?.header) shopifyHeaderSet.add(sh.header.trim());
  //       });
  //     });
  //     parsedTemplate?.tagsMapping?.forEach(tag => {
  //       if (tag?.mappedHeader) csvHeaderSet.add(tag.mappedHeader.trim());
  //     });
  //     parsedTemplate?.metafieldMapping?.forEach(meta => {
  //       if (meta?.csvHeaders) csvHeaderSet.add(meta.csvHeaders.trim());
  //     });
  //     const csvHeaders = Array.from(csvHeaderSet);
  //     const shopifyHeaders = Array.from(shopifyHeaderSet);
  //     setFtpHeaders(csvHeaders);
  //     const optionsWithDefault = [
  //       "Select a value",
  //       ...shopifyHeaders
  //     ];

  //     setShopifyFields(optionsWithDefault);
  //     setPresetModalActive(true);
  //     setSelectedTemplate(id);
  //   }
  //   else {
  //     setSelectedTemplateID("0");
  //   }
  // };


  function getTemplates() {
    getMappedTemplates(storeUrl, "FTP").then(function (result) {
      if (result !== null) {
        setExistingTemplates(result);
        const existingTemp = [{
          id: "0",
          name: "Select a Template",
          template: "{}"
        }];
        existingTemp.push(...result);
        // setExistingTemplates(result);
        // setTemplateOptions(existingTemp.map((template) => ({
        //   label: template.name,
        //   value: template?.id?.toString(),
        // })));
      }
      else {
        // setTempLoading(false);
      }
    });
  }

  const saveIntegrationConfig = async () => {
    try {
      setSaveLoading(true);

      let configToSave = { ...integrationConfig }; // Create a copy of the existing config

      configToSave.ImportFormat = "FTP";
      configToSave.ftpConfig = ftpConfig;
      // Ensure timezone is set, with fallback to first timezone option
      configToSave.timeZone = integrationConfig.timeZone || timezoneOptions[0]?.value || 'UTC';
      configToSave.templateId = templateId !== "0" ? templateId : selectedTemplateID;


      if (!configToSave) {
        setSaveLoading(false);
        return;
      }
      else {
        await fetch(`${endpoint}/api/Integrations/add-config?storeUrl=${storeUrl}&importType=${"FTP"}`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ feedUrl: configToSave.xmlUrl, cronExpression: configToSave.cronExpression, jobName: configToSave.jobName, jobId, ftpConfig: configToSave.ftpConfig, timeZone: configToSave.timeZone, templateId: configToSave.templateId }),
        });
        setSaveLoading(false);
        // getConfig();
        setToast(true);
        setSetupActive(false);
        setCompletedSteps((prev) => ({ ...prev, step1: false, step2: false }));
        setXmlConfigAction('');
        setJobId(null);
        // Refresh the config list in the parent component
        if (refreshConfigList) {
          refreshConfigList();
        }
      }
    } catch (error) {

    }
  }

  const GetFtpConfig = async (pageNo = 1, pageSize = 10) => {
    try {
      const response = await axios.get(`${endpoint}/api/Integrations/ftp-configs`, {
        params: {
          storeUrl,
          pageNo,
          pageSize,
        },
      });

      if (response.status === 200) {
        setSavedConfigs(response.data?.ftpConfigs);
        setHasMore(response.data?.totalPages > pageNo);
      }
    } catch (err) {

    }
  };




  const ACCORDION_ITEMS = [
    {
      id: 1,
      completed: (action === "edit" || action === "editExpand") ? true : completed.step1 || false,
      title: (action === "edit" || action === "editExpand") ? "Edit Existing Feed" : "Create New Feed",
      content: (
        <>
          {FormLoading ? (
            <s-stack direction="inline" align='center'>
              <s-spinner
                accessibilityLabel="Loading form field"
                size="small"
              />
            </s-stack>
          ) : (
            <>
              {schedulerConfig}

            </>
          )}
        </>
      )
    },
    {
      id: 2,
      title: "Template Mapping",
      completed: (action === "edit" || action === "editExpand") ? true : completed.step2 || false,
      content: (
        <>
          {(action === "edit" || action === "editExpand") ? (
            <>
              <s-text as='p' tone='subdued'>
                This section allows you to map values from your data feed to corresponding Shopify fields.
              </s-text>
              {(selectedTemplateID !== "0" && selectedTemplateID !== undefined && selectedTemplateID !== null && selectedTemplateID !== 0 && ftpFields?.length > 0 && shopifyHeaders?.length > 0) ? (
                <CSVMapping
                  cancelUpload={() => setPresetModalActive(false)}
                  uploadError={() => setPresetModalActive(false)}
                  submitUpload={() => setPresetModalActive(false)}
                  csvHeaders={ftpFields}
                  incomingShopifyHeaders={shopifyFields}
                  activate={presetModalActive}
                  file={null}
                  storeUrl={storeUrl}
                  dbTagSeparator={""}
                  currentRoute={"preset"}
                  uploadType={"FTP"}
                  ftpConfig={null}
                  templateEditId={selectedTemplate}
                  setCompletedSteps={setCompletedSteps}
                />
              ) : (
                mappingHtml
              )}
            </>
          ) : (action === "create" || action === "createExpand") && ftpConfig.isSuccess ? (
            <>
              <s-text as='p' tone='subdued'>
                This section allows you to map values from your data feed to corresponding Shopify fields.
              </s-text>
              {mappingHtml}
            </>
          ) : (
            <s-banner title="Test FTP connection to enable template mapping." tone="info">
              <s-text>
                Please ensure that the FTP connection is successfully tested in the "Create New Feed" section before proceeding to template mapping.
              </s-text>
            </s-banner>
          )}
        </>
      )

    }
  ];
  const completedItemsLength = ACCORDION_ITEMS.filter((item) => item.completed).length;

  const accordianMarkup = (
    <s-stack gap="none">
      {ACCORDION_ITEMS.map(({ title, id, content, completed }) => {
        const isExpanded = expanded === id;
        return (
          <s-box
            key={id}
            background="bg-surface"
            border="none"
            padding="none"
          >
            <s-clickable
              border="base"
              padding="base"
              background="subdued"
              borderRadius="base"
              onClick={() => {
                setExpanded((prev) => (id === prev ? null : id));

                if (id === 2 && (action === "edit" || action === "editExpand")) {
                  handleEdit(selectedTemplateID);
                }
                if (id === 2 && (action === "create" || action === "createExpand") && ftpConfig.isSuccess) {
                  setSelectedTemplateID("0");
                  fetchMappingData();
                }
                if (action === "create" || action === "createExpand") {
                  setXmlConfigAction("createExpand");
                } else {
                  setXmlConfigAction("editExpand");
                }
              }}
            >
              <s-stack direction="inline" align="space-between" blockAlign="center">
                <s-stack direction="inline" gap="base" blockAlign="center">
                  {completed ? (
                    <s-icon type="status-active" />
                  ) : (
                    <s-icon type="status" />
                  )}
                  <s-text type="strong">{title}</s-text>
                </s-stack>
                <s-icon type={isExpanded ? "chevron-up" : "chevron-down"} />
              </s-stack>
            </s-clickable>

            {isExpanded && (
              <s-box padding="base" background="bg-surface">
                {content}
              </s-box>
            )}
          </s-box>
        );
      })}
    </s-stack>
  );



  return (
    <>
      <style>
        {`
          /* Parent FTP Connection Modal */
          #ftp-connection-modal {
            z-index: 1000 !important;
          }
          #ftp-connection-modal::part(overlay) {
            z-index: 999 !important;
          }
          #ftp-connection-modal::part(dialog) {
            z-index: 1001 !important;
          }
          
          /* Nested Edit Schedule Modal - Higher z-index to appear on top */
          #cron-edit-modal-ftp {
            z-index: 1100 !important;
          }
          #cron-edit-modal-ftp::part(overlay) {
            z-index: 1099 !important;
          }
          #cron-edit-modal-ftp::part(dialog) {
            z-index: 1101 !important;
          }
        `}
      </style>
      {/* <InlineStack align='end' blockAlign='center' spacing='extraTight'>
        <Button
          variant='primary'
          onClick={() => { handleSetupOpen(); setXmlConfigAction('create'); setSelectedTemplateID("0"); setJobId(null); }}
          size='large'
        >
          Create
        </Button>
      </InlineStack> */}
      <s-modal
        padding="none"
        id="ftp-connection-modal"
        heading={(action === 'edit' || action === "editExpand") ? 'Edit FTP Connection' : 'Create new FTP Connection'}
        size='large'
      >
        {accordianMarkup}

        <s-stack slot="secondary-actions" direction="inline" gap='small' blockAlign='center'>
          {completedItemsLength === ACCORDION_ITEMS.length ? (
            <>
              <s-icon type="check" tone='subdued' />
              <s-text tone='subdued'>Done</s-text>
            </>
          ) : (
            <>
              <s-text tone='subdued'>
                {`${completedItemsLength} / ${ACCORDION_ITEMS.length} completed`}
              </s-text>
              <div style={{ width: '120px' }}>
                <s-progress-bar
                  progress={(completedItemsLength / ACCORDION_ITEMS.length) * 100}
                  size='small'
                  tone='primary'
                />
              </div>
            </>
          )}
        </s-stack>

        <s-button
          slot="primary-action"
          variant="primary"
          loading={saveLoading}
          disabled={action === "edit" || action === "editExpand" ? false : (completed.step1 === false || completed.step2 === false)}
          onClick={() => { saveIntegrationConfig(); }}
        >
          Save
        </s-button>
      </s-modal>
      {/* <br />
      <Card roundedAbove="sm" padding="0">
        {schedulerConfigHistory}
      </Card> */}

      <ToastMarkup toast={toast} toggleToast={toggleToast} content={"Saved"} />
    </>
  );
};


export default FTPConnection;
